<template>
  <div class="paper-analysis-page">
    <template v-if="$route.name === 'paperAnalysis'">
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

      <ots-table-group-new
        v-loading="loading"
        :selectList="selectList"
        :requestForm="selectForm"
        :tableHeader="tableHeader"
        :tableOption="tableOption"
        :tableData="tableData"
        :pagination="pagination"
        @search="search"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>

    <!-- 新建/编辑任务弹窗 -->
    <CreateTaskDialog
      ref="createTaskDialog"
      @success="loadData"
    />
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getTaskListAPI, deleteTaskAPI, startTaskAPI, stopTaskAPI } from '@/http/modules/examSet/paperAnalysis'
import CreateTaskDialog from './components/CreateTaskDialog'

const STATUS_MAP = {
  0: '待开始',
  1: '队列中',
  2: '进行中',
  3: '已完成',
  4: '已终止',
  5: '分析失败'
}

export default {
  name: 'PaperAnalysis',
  components: { CreateTaskDialog },
  data() {
    return {
      loading: false,
      mainTopBtnList: [
        { title: '新增分析任务', fn: this.handleCreate }
      ],
      selectForm: {
        taskName: '',
        status: '',
        createTime: [],
        page: 1,
        size: 10
      },
      selectList: [
        { title: '任务名称', type: 'input', requestKey: 'taskName', placeholder: '请输入任务名称' },
        { title: '任务状态', type: 'select', requestKey: 'status', label: 'label', value: 'value', data: [
          { label: '全部', value: '' },
          { label: '待开始', value: 0 },
          { label: '队列中', value: 1 },
          { label: '进行中', value: 2 },
          { label: '已完成', value: 3 },
          { label: '已终止', value: 4 },
          { label: '分析失败', value: 5 }
        ]},
        { title: '创建时间', type: 'daterange', requestKey: 'createTime' }
      ],
      tableHeader: [
        { title: '任务名称', prop: 'taskName', width: 150 },
        { title: '考试科目', prop: 'subjects', width: 200 },
        { title: '试卷名称', prop: 'papers', width: 200 },
        { title: '任务状态', prop: 'statusName', width: 120, type: 'tag_Q', tagColor: this.getStatusClass },
        { title: '分析进度', prop: 'progress', width: 120, formatter: this.formatProgress },
        { title: '创建时间', prop: 'createTime', width: 180 },
        { title: '完成时间', prop: 'completeTime', width: 180 },
        {
          title: '操作',
          type: 'buttons',
          width: 360,
          btnList: [
            { title: '修改参数', click: this.handleModify  },
            { title: '开始分析', click: this.handleStart, formatter: scope => scope.row.status !== 0 },
            { title: '重新分析', click: this.handleRestart, formatter: scope => ![3, 4, 5].includes(scope.row.status) },
            { title: '查看结果', click: this.handleViewResult, formatter: scope => scope.row.status !== 3 },
            { title: '删除', click: this.handleDelete, formatter: scope => scope.row.status !== 0 }
          ]
        }
      ],
      tableOption: {},
      tableData: [],
      pagination: {
        total: 0,
        page: 1,
        size: 10
      },
      progressTimer: null
    }
  },
  created() {
    this.loadData()
  },
  beforeDestroy() {
    this.clearProgressTimer()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const [createTimeStart = '', createTimeEnd = ''] = this.selectForm.createTime || []
        const params = {
          taskName: this.selectForm.taskName,
          status: this.selectForm.status,
          createTimeStart,
          createTimeEnd,
          page: this.selectForm.page,
          size: this.selectForm.size
        }
        const res = await getTaskListAPI(params)
        if (res.code === 1 && res.data) {
          this.tableData = (res.data.records || []).map(item => ({
            ...item,
            statusName: STATUS_MAP[item.status] || '未知'
          }))
          this.pagination.total = res.data.total || 0
          this.pagination.page = this.selectForm.page
          this.pagination.size = this.selectForm.size
          this.checkProgressPolling()
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    search() {
      this.selectForm.page = 1
      this.loadData()
    },
    changeSize(val) {
      this.selectForm.size = val
      this.selectForm.page = 1
      this.pagination.size = val
      this.loadData()
    },
    changePage(val) {
      this.selectForm.page = val
      this.pagination.page = val
      this.loadData()
    },
    handleCreate() {
      this.$refs.createTaskDialog.open()
    },
    handleModify(row) {
      this.$refs.createTaskDialog.open(row)
    },
    async handleStart(row) {
      try {
        await this.$confirm('确定开始分析该任务？', '提示', { type: 'warning' })
        const res = await startTaskAPI({ taskId: row.taskId })
        if (res.code === 1) {
          this.$message.success('分析任务已启动')
          this.loadData()
        } else {
          this.$message.error(res.msg || '启动失败')
        }
      } catch (e) { /* cancel */ }
    },
    async handleRestart(row) {
      try {
        await this.$confirm('重新分析将覆盖之前的分析结果，是否确定？', '提示', { type: 'warning' })
        const res = await startTaskAPI({ taskId: row.taskId })
        if (res.code === 1) {
          this.$message.success('分析任务已重新启动')
          this.loadData()
        } else {
          this.$message.error(res.msg || '启动失败')
        }
      } catch (e) { /* cancel */ }
    },
    async handleStop(row) {
      try {
        await this.$confirm('确定终止该分析任务？', '提示', { type: 'warning' })
        const res = await stopTaskAPI({ taskId: row.taskId })
        if (res.code === 1) {
          this.$message.success('任务已终止')
          this.loadData()
        } else {
          this.$message.error(res.msg || '终止失败')
        }
      } catch (e) { /* cancel */ }
    },
    handleViewResult(row) {
      this.$router.push({ name: 'paperAnalysisResult', query: { taskId: row.taskId } })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该分析任务？', '提示', { type: 'warning' })
        const res = await deleteTaskAPI({ taskId: row.taskId })
        if (res.code === 1) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (e) { /* cancel */ }
    },
    getStatusClass(scope) {
      const status = scope && scope.row ? scope.row.status : scope
      const map = { 0: 'status-pending', 1: 'status-queue', 2: 'status-running', 3: 'status-done', 4: 'status-stopped', 5: 'status-failed' }
      return map[status] || ''
    },
    formatProgress(scope) {
      const progress = scope.row.progress || 0
      return `${progress}%`
    },
    checkProgressPolling() {
      const hasRunning = this.tableData.some(item => item.status === 1 || item.status === 2)
      if (hasRunning && !this.progressTimer) {
        this.progressTimer = setInterval(() => this.loadData(), 5000)
      } else if (!hasRunning && this.progressTimer) {
        this.clearProgressTimer()
      }
    },
    clearProgressTimer() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.paper-analysis-page {
  padding:0px 20px;
}
/deep/ .otstablenew .operate .el-button.is-disabled {
  display: none;
}
.status-pending { color: #909399; }
.status-queue { color: #E6A23C; }
.status-running { color: #409EFF; }
.status-done { color: #67C23A; }
.status-stopped { color: #909399; }
.status-failed { color: #F56C6C; }

</style>
